import React, {useRef, useCallback, useContext, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ClickableIconLabel from '../../../../../ClickableIconLabel/ClickableIconLabel';
import CreateEditITApplicationModalWrapper from '../../../../../EntityCrud/CreateEditITApplicationModalWrapper';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

export default function ISA315ItApplicationToolbar({className, label, disabled, isStandalone}) {
	const [showModal, setShowModal] = useState(false);

	return (
		<StyledISA315ItApplicationToolbar className={`StyledISA315ItApplicationToolbar ${className}`}>
			<ClickableIconLabel
				disabled={disabled}
				text={label}
				iconName={IconoirPlusCircle}
				onClick={() => setShowModal(!showModal)}
			/>
			{!disabled && (
				<CreateEditITApplicationModalWrapper
					isCreate
					showModal={showModal}
					setShowModal={setShowModal}
					isStandalone={isStandalone}
				/>
			)}
		</StyledISA315ItApplicationToolbar>
	);
}

ISA315ItApplicationToolbar.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	children: PropTypes.node,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	entityId: PropTypes.number,
	bodyId: PropTypes.number.isRequired
};

ISA315ItApplicationToolbar.defaultProps = {
	className: 'body-special-toolbar-button',
	disabled: false
};

const StyledISA315ItApplicationToolbar = styled.section`
	display: flex;
	align-items: flex-end;
	margin-left: auto;
`;
